'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signUp = exports.signIn = exports.validateToken = exports.resetPassword = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _base = require('../../../utils/base64');

var resetPassword = exports.resetPassword = function resetPassword(_ref) {
  var _ref$email = _ref.email,
      email = _ref$email === undefined ? (0, _params.required)() : _ref$email;
  return (0, _client.get)('v1/account/' + email + '/requestpasswordreminder');
};

var validateToken = exports.validateToken = function validateToken() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return _client.jgIdentityClient.get('/connect/accesstokenvalidation?token=' + token).then(function (response) {
    return _extends({}, response.data, { valid: true });
  }).catch(function (_ref2) {
    var response = _ref2.response;
    return _extends({}, response.data, { valid: false });
  });
};

var signIn = exports.signIn = function signIn(_ref3) {
  var _ref3$email = _ref3.email,
      email = _ref3$email === undefined ? (0, _params.required)() : _ref3$email,
      _ref3$password = _ref3.password,
      password = _ref3$password === undefined ? (0, _params.required)() : _ref3$password;

  var token = (0, _base.encodeBase64String)(email + ':' + password);

  return (0, _client.get)('v1/account', {}, {}, {
    headers: {
      Authorization: 'Basic ' + token
    }
  }).then(function (data) {
    return {
      address: data.address,
      email: data.email,
      name: [data.firstName, data.lastName].join(' '),
      token: token,
      userId: data.userId
    };
  });
};

var signUp = exports.signUp = function signUp(_ref4) {
  var _ref4$firstName = _ref4.firstName,
      firstName = _ref4$firstName === undefined ? (0, _params.required)() : _ref4$firstName,
      _ref4$lastName = _ref4.lastName,
      lastName = _ref4$lastName === undefined ? (0, _params.required)() : _ref4$lastName,
      _ref4$email = _ref4.email,
      email = _ref4$email === undefined ? (0, _params.required)() : _ref4$email,
      _ref4$password = _ref4.password,
      password = _ref4$password === undefined ? (0, _params.required)() : _ref4$password,
      address = _ref4.address,
      title = _ref4.title,
      cause = _ref4.cause,
      reference = _ref4.reference;

  var payload = {
    acceptTermsAndConditions: true,
    firstName: firstName,
    lastName: lastName,
    email: email,
    password: password,
    title: title,
    address: address,
    reference: reference,
    causeId: cause
  };

  var request = address ? (0, _client.put)('v1/account', payload) : (0, _client.post)('v1/account/lite', payload);

  return request.then(function (data) {
    return {
      address: address,
      country: data.country,
      email: email,
      firstName: firstName,
      lastName: lastName,
      name: [firstName, lastName].join(' '),
      token: (0, _base.encodeBase64String)(email + ':' + password)
    };
  });
};